/**
 * @module profile/components/portfolio/form_entry_info
 */
import React, { Component, PropTypes } from 'react';
import { Field } from 'redux-form';
import { TextAreaField, TextInputField, SelectField } from 'common/components/form_fields';

/**
 * HTML form for the portfolio form info step
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class FormEntryInfo extends Component {
  componentDidMount() {
    this.props.fetchCategoriesIfNeeded();
    this.props.fetchIndustriesIfNeeded();
  }

  render() {
    const { subCategories, industries } = this.props;
    const subCatOptions = subCategories.map(subCat => ({ field: subCat.id, label: subCat.name }));
    const industryOptions = industries.map(ind => ({ field: ind.id, label: ind.name }));

    return (
      <form className="">
        <div className="row columns">
          <h3>Title</h3>
          <p>Provide a short title for this design.</p>
          <Field
            component={TextInputField}
            label="title"
            name="portfolio_title"
          />
        </div>
        <div className="row columns">
          <h3>Description</h3>
          <p>The description helps clients understand the rationale for your design.</p>
          <Field
            component={TextAreaField}
            validate={(val) => !val ? 'empty' : undefined}
            name="portfolio_description"
          />
        </div>
        <div className="row">
          <div className="small-8 column">
            {/* Although it reads 'Category' below, we're really listing sub-categories. */}
            <h3>Category</h3>
            <Field component={SelectField}
              name="portfolio_subcategory"
              options={subCatOptions}
              allowEmpty={true}
            />
          </div>
          <div className="small-8 column">
            <h3>Industry</h3>
            <Field component={SelectField}
              name="portfolio_industry"
              options={industryOptions}
              allowEmpty={true}
            />
          </div>
        </div>
      </form>
    );
  }
}

FormEntryInfo.propTypes = {
  subCategories: PropTypes.array,
  industries: PropTypes.array,
  fetchCategoriesIfNeeded: PropTypes.func,
  fetchIndustriesIfNeeded: PropTypes.func,
};



// WEBPACK FOOTER //
// ./profile/components/portfolio/form_entry_info.jsx